module.exports = __webpack_public_path__ + "img/main-bg-mobile.4752e145.svg";